import { useEffect, useState } from "react";
import {
    ADMIN_CONTROLS_EVENT,
    ADMIN_CONTROLS_STORAGE_KEY,
    readAdminControlsSettings,
    type AdminControlsSettings,
} from "@/utils/adminControls";

const selectBranding = (settings: AdminControlsSettings) => ({
    logoUrl: settings.logoUrl,
    logoAlt: settings.logoAlt,
    mobileLogoUrl: settings.mobileLogoUrl || settings.logoUrl,
    logoScale: settings.logoScale,
    logoPositionX: settings.logoPositionX,
    logoPositionY: settings.logoPositionY,
    mobileLogoScale: settings.mobileLogoScale,
    mobileLogoPositionX: settings.mobileLogoPositionX,
    mobileLogoPositionY: settings.mobileLogoPositionY,
    tvLogoUrl: settings.tvLogoUrl,
    tvLogoScale: settings.tvLogoScale,
    tvLogoPositionX: settings.tvLogoPositionX,
    tvLogoPositionY: settings.tvLogoPositionY,
    compactLogoUrl: settings.compactLogoUrl || settings.logoUrl,
    qrLogoUrl: settings.qrLogoUrl || settings.logoUrl,
    qrLogoBackground: settings.qrLogoBackground,
    socialImageUrl: settings.socialImageUrl || settings.logoUrl,
});

export const useBranding = () => {
    const [branding, setBranding] = useState(() => selectBranding(readAdminControlsSettings()));

    useEffect(() => {
        const refresh = () => setBranding(selectBranding(readAdminControlsSettings()));
        const handleUpdate = (event: Event) => {
            const next = (event as CustomEvent<AdminControlsSettings>).detail;
            setBranding(selectBranding(next || readAdminControlsSettings()));
        };
        const handleStorage = (event: StorageEvent) => {
            if (event.key === ADMIN_CONTROLS_STORAGE_KEY) refresh();
        };

        window.addEventListener(ADMIN_CONTROLS_EVENT, handleUpdate);
        window.addEventListener("storage", handleStorage);
        return () => {
            window.removeEventListener(ADMIN_CONTROLS_EVENT, handleUpdate);
            window.removeEventListener("storage", handleStorage);
        };
    }, []);

    return branding;
};
